module.exports = __webpack_public_path__ + "static/media/banner_loja.c62098f1.jpg";